import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1a1977b0&scoped=true&"
import script from "./App.vue?vue&type=script&lang=ts&"
export * from "./App.vue?vue&type=script&lang=ts&"
import style0 from "./styles/main.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./App.vue?vue&type=style&index=1&id=1a1977b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1977b0",
  null
  
)

export default component.exports